import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

const tableStyle = {
  'borderCollapse':'separate',
  'fontSize':'12px'
};
const tableHeaderStyle = {
  'backgroundColor':'#337ab7',
  color:'white'
};
const tdStyle = { 'whiteSpace': 'pre' };

export default class AcquisitionTelemetryChartComponent extends Component {

    static propTypes = { exceptions: PropTypes.array.isRequired };

    render() {
      const data = this.props.exceptions;
      const length = data.length;

      if (length === 0) {
        return (
          <div>
          &nbsp;
            <p><font color="#337ab7"><b> {length} EXCEPTIONS FOUND </b></font></p>
          </div>
        );
      }

      for (let i = 0; i < length; i++ ) {
        const val = data[i];
        val.Domain = JSON.stringify(val.Domain).split(',').join('\n');
        val.Domain = val.Domain.replace( /[{""}]/g, '' );

        val.Exception = val.Exception.InnerExceptions.length === 1 ?
          val.Exception.InnerExceptions[0] : val.Exception;
        for (const key in val.Exception) {
          val.Exception[key] = JSON.stringify(key).replace( /[""]/g, '' ) +
          ': ' +
          JSON.stringify(val.Exception[key]).replace( /[""]/g, '' ) +
          '\n';
        }
        val.Exception = Object.values(val.Exception);

        for ( let j = 0; j < val.Statistics.length; j++) {
          val.Statistics[j] = Object.values(val.Statistics[j]);
          val.Statistics[j] = JSON.stringify(val.Statistics[j]).split(',').join(':');
          val.Statistics[j] = val.Statistics[j].replace( /["''"]/g, '' )
            .replace(/[[\]]/g, '') + '\n';
        }
        data[i] = val;
      }

      return (
        <div>
          &nbsp;
          <p><font color="#337ab7"><b> {length} EXCEPTIONS FOUND </b></font></p>
          <Table striped hover style={tableStyle} bordered>
            <thead>
              <tr style={tableHeaderStyle}>
                <th>Domain</th>
                <th>Statistics</th>
                <th>Exception</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map(this.renderData)}
            </tbody>
          </Table>
        </div>
      );

    }

    renderData(data, index) {
      return (
        <tr key={index}>
          <td>{data.Domain}</td>
          <td>{data.Statistics}</td>
          <td style={tdStyle}>{data.Exception}</td>
        </tr>
      );
    }
}



// WEBPACK FOOTER //
// src/Components/AcquisitionTelemetryChartComponent.jsx